import {DialogProps} from "../DialogProps";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography
} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {ListBox, ListBoxItemClickEvent} from '@progress/kendo-react-listbox';
import styles from "./_j-d-powersport-dialog.module.scss";
import {IApplication} from "../../../Interfaces/Application/IApplication";
import { AppState } from '../../../store/rootReducer';
import {getEmployeeName} from "../../../utils/utils";
import {useDialog} from "../../../providers/DialogProvider";
import Backdrop from "@mui/material/Backdrop";
import {IJDPowersportModel} from "../../../Interfaces/JDPower/IJDPowersportModel";
import {IConfiguration} from "../../../Data/ConfigurationData";
import {hasValue, LoadingPanel} from "@amsanalytics/react-shared-library";

export interface JDPowersportDialogProps extends DialogProps<void> {
  currentApp: IApplication;
  availableModels: IJDPowersportModel[];
  handleSave: (modelToSave: IJDPowersportModel, jdPowersportValueTypeToSave: string | undefined) => void;
  configuration: IConfiguration;
  getValueForValueType: (type: string, model: IJDPowersportModel | undefined) => number;
}

export default function JDPowersportDialog(props: JDPowersportDialogProps) {
  const [openDialog, closeDialog] = useDialog();
  const vehicle = props.currentApp.vehicle!;
  const employees = useSelector((state: AppState) => state.applications.employees);
  const vehicleJdPowersport = vehicle.vehicleJdPowersport;
  const [availableModels, setAvailableModels] = useState<IJDPowersportModel[]>(props.availableModels);
  const [selectedModel, setSelectedModel] = useState<IJDPowersportModel | undefined>();
  const [jdPowersportValueType, setJdPowersportValueType] = useState<string>(vehicleJdPowersport ? vehicleJdPowersport.valueType : props.configuration.defaultJdPowersportValueType ?? "MSRP");
  const [loading, setLoading] = useState<boolean>(false);
  const firstAvailableModel = availableModels.length > 0 ? availableModels[0] : undefined;

  // Runs on first load
  useEffect(() => {
    if (vehicleJdPowersport && hasValue(vehicleJdPowersport?.id)) {
      // Setting/selecting all the previously saved data
      setJdPowersportValueType(vehicleJdPowersport.valueType);
      setAvailableModels(availableModels.map(m => {
        if (m.modelID === vehicleJdPowersport.modelId) {
          m.selected = true;
          setSelectedModel(m);
        }
        return m;
      }));
    }
  }, []);

  const handleModelSelect = async (e: ListBoxItemClickEvent) => {
    setAvailableModels(availableModels?.map(am => {
      am.selected = am.modelID === e.dataItem.modelID;
      return am;
    }));
    setSelectedModel(availableModels?.find(am => am.selected));
  }

  const handleSave = async () => {
    setLoading(true);
    if (selectedModel) {
      await props.handleSave(selectedModel, jdPowersportValueType);
      setLoading(false);
    }
    closeDialog();
  }

  const pulledByName = getEmployeeName(employees, vehicleJdPowersport?.pulledById);

  const leftColumnWidth = 12;
  // const rightColumnWidth = 7;

  // const vehicleLabelWidth = 3;
  // const vehicleValueWidth = 9;

  return (
    <div className={styles.jDPowersportDialogContainer}>
      <DialogTitle id="form-dialog-title">
        Decode VIN
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={1} className={styles.parentGrid}>
          <Grid item xs={leftColumnWidth}>
            {hasValue(vehicle.stockNumber) &&
              <Grid item xs={12}>
                <Typography>{`Stock: ${vehicle.stockNumber}`}</Typography>
              </Grid>
            }
            {firstAvailableModel &&
              <Grid item xs={12}>
                <Typography>{`Vehicle: ${firstAvailableModel.year} ${firstAvailableModel.make}`}</Typography>
              </Grid>
            }
          </Grid>
          {/*<Grid item xs={rightColumnWidth}>
            <RadioGroup
              aria-label="value-type"
              name="value-type"
              value={jdPowersportValueType}
              onChange={(e) => setJdPowersportValueType(e.target.value as string)}
              row
            >
              <FormControlLabel
                value="MSRP"
                control={<Radio color="primary" />}
                label={`MSRP- ${toDollars(props.getValueForValueType("MSRP", selectedModel))}`}
                labelPlacement="end"
              />
              <FormControlLabel
                value="LowRetail"
                control={<Radio color="primary" />}
                label={`Low Retail- ${toDollars(props.getValueForValueType("LowRetail", selectedModel))}`}
                labelPlacement="end"
              />
              <FormControlLabel
                value="AverageRetail"
                control={<Radio color="primary" />}
                label={`Average Retail- ${toDollars(props.getValueForValueType("AverageRetail", selectedModel))}`}
                labelPlacement="end"
              />
              <FormControlLabel
                value="LowTrade"
                control={<Radio color="primary" />}
                label={`Low Trade- ${toDollars(props.getValueForValueType("LowTrade", selectedModel))}`}
                labelPlacement="end"
              />
              <FormControlLabel
                value="HighTrade"
                control={<Radio color="primary" />}
                label={`High Trade- ${toDollars(props.getValueForValueType("HighTrade", selectedModel))}`}
                labelPlacement="end"
              />
              <FormControlLabel
                value="AverageWholesale"
                control={<Radio color="primary" />}
                label={`Average Wholesale- ${toDollars(props.getValueForValueType("AverageWholesale", selectedModel))}`}
                labelPlacement="end"
              />
            </RadioGroup>
          </Grid>*/}

          {/*Left Column*/}
          <Grid item xs={leftColumnWidth}>
            <Grid item xs={12} className={styles.topSpacer}>
              <TextField
                disabled
                error={!hasValue(vehicle.vin)}
                style={{ textAlign: 'right' }}
                fullWidth
                label='VIN'
                value={vehicle.vin}
                size='small'
                variant='outlined'
                inputProps={{ style: { textAlign: 'right' } }}
              />
            </Grid>
            {/*<Grid item xs={12} className={styles.topSpacer}>
              <TextField
                disabled
                style={{ textAlign: 'right' }}
                fullWidth
                label='Mileage'
                value={vehicle.mileage ?? 0}
                size='small'
                variant='outlined'
                inputProps={{ style: { textAlign: 'right' } }}
              />
            </Grid>*/}
            <Grid item xs={12} className={styles.topSpacer}>
              <Typography style={{marginLeft: "0px"}}>Models</Typography>
              <ListBox
                style={{width: "100%"}}
                data={availableModels ?? []}
                textField={"modelDescription"}
                selectedField={"selected"}
                draggable={false}
                onItemClick={(e) => handleModelSelect(e)}
              />
            </Grid>
            {hasValue(vehicleJdPowersport?.pulledById) && vehicleJdPowersport?.pulledDate !== undefined &&
              <Grid item xs={12} className={styles.topSpacer}>
                <Typography>
                  {`Saved By: ${pulledByName} at ${new Date(vehicleJdPowersport!.pulledDate).toLocaleString()}`}
                </Typography>
              </Grid>
            }
          </Grid>

          {/*Right Column*/}
          {/*<Grid item container xs={rightColumnWidth}>
            <Grid item xs={vehicleLabelWidth} className={styles.topSpacer}>
              <Typography className={styles.labelText}>
                Make:
              </Typography>
            </Grid>
            <Grid item xs={vehicleValueWidth} className={styles.topSpacer}>
              <Typography>
                {selectedModel?.make ?? ""}
              </Typography>
            </Grid>
            <Grid item xs={vehicleLabelWidth} className={styles.topSpacer}>
              <Typography className={styles.labelText}>
               Year:
              </Typography>
            </Grid>
            <Grid item xs={vehicleValueWidth} className={styles.topSpacer}>
              <Typography>
                {selectedModel?.year ?? ""}
              </Typography>
            </Grid>
            <Grid item xs={vehicleLabelWidth} className={styles.topSpacer}>
              <Typography className={styles.labelText}>
                Model:
              </Typography>
            </Grid>
            <Grid item xs={vehicleValueWidth} className={styles.topSpacer}>
              <Typography>
                {selectedModel?.model ?? ""}
              </Typography>
            </Grid>
            <Grid item xs={vehicleLabelWidth} className={styles.topSpacer}>
              <Typography className={styles.labelText}>
                Model Type:
              </Typography>
            </Grid>
            <Grid item xs={vehicleValueWidth} className={styles.topSpacer}>
              <Typography>
                {selectedModel?.modelType ?? ""}
              </Typography>
            </Grid>
            <Grid item xs={vehicleLabelWidth} className={styles.topSpacer}>
              <Typography className={styles.labelText}>
                Transmission:
              </Typography>
            </Grid>
            <Grid item xs={vehicleValueWidth} className={styles.topSpacer}>
              <Typography>
                {selectedModel?.transmission ?? ""}
              </Typography>
            </Grid>
            <Grid item xs={vehicleLabelWidth} className={styles.topSpacer}>
              <Typography className={styles.labelText}>
                Weight:
              </Typography>
            </Grid>
            <Grid item xs={vehicleValueWidth} className={styles.topSpacer}>
              <Typography>
                {selectedModel?.weight ?? ""}
              </Typography>
            </Grid>
            <Grid item xs={vehicleLabelWidth} className={styles.topSpacer}>
              <Typography className={styles.labelText}>
                Engine CC:
              </Typography>
            </Grid>
            <Grid item xs={8} className={styles.topSpacer}>
              <Typography>
                {selectedModel?.engineCC ?? ""}
              </Typography>
            </Grid>
            <Grid item xs={vehicleLabelWidth} className={styles.topSpacer}>
              <Typography className={styles.labelText}>
                Stroke:
              </Typography>
            </Grid>
            <Grid item xs={vehicleValueWidth} className={styles.topSpacer}>
              <Typography>
                {selectedModel?.stroke ?? ""}
              </Typography>
            </Grid>
            <Grid item xs={vehicleLabelWidth} className={styles.topSpacer}>
              <Typography className={styles.labelText}>
                Cylinders:
              </Typography>
            </Grid>
            <Grid item xs={vehicleValueWidth} className={styles.topSpacer}>
              <Typography>
                {selectedModel?.cylinders ?? ""}
              </Typography>
            </Grid>
          </Grid>*/}
        </Grid>

        <DialogActions>
          <Button
            disabled={!selectedModel}
            onClick={handleSave}
            color="primary"
            variant="contained"
          >
            Save
          </Button>
          <Button
            autoFocus
            onClick={props.closeDialog}
            color="secondary"
            variant="contained"
          >
            Close
          </Button>
        </DialogActions>
      </DialogContent>

      <Backdrop className={styles.backdrop} open={loading}>
        <LoadingPanel label='' />
      </Backdrop>
    </div>
  );
};
